import { Component } from 'react';

export type ApiVersionWrapperStateProps = {
  readonly apiVersion: string;
};

export type ApiVersionWrapperOwnProps = {
  readonly predicate: (apiVersion: string) => boolean;
  readonly children: JSX.Element;
};

export type ApiVersionWrapperProps = ApiVersionWrapperStateProps & ApiVersionWrapperOwnProps;

export default class ApiVersionWrapper extends Component<ApiVersionWrapperProps> {
  public override render(): JSX.Element | null {
    const { apiVersion, predicate, children } = this.props;
    return predicate(apiVersion) ? children : null;
  }
}
